var map = {
	"./128x128.png": 969,
	"./144x144.png": 970,
	"./152x152.png": 971,
	"./192x192.png": 972,
	"./256x256.png": 973,
	"./512x512.png": 974,
	"./Alan.png": 975,
	"./Document.svg": 612,
	"./DocumentError.svg": 976,
	"./Ellipse 3 rojo.svg": 977,
	"./Ellipse 3.svg": 978,
	"./Ellipse 3Error.svg": 979,
	"./abierta.svg": 395,
	"./add-location-white.svg": 980,
	"./add-location.svg": 981,
	"./add.svg": 982,
	"./agricultura-2.svg": 313,
	"./agricultura.svg": 404,
	"./alimentaria-2.svg": 405,
	"./alimentaria.svg": 389,
	"./ambiental-2.svg": 406,
	"./ambiental.svg": 390,
	"./analytics-preview.svg": 312,
	"./anotaciones_lab.svg": 391,
	"./apple-touch-icon.png": 983,
	"./black_warning.svg": 984,
	"./calendar-white.svg": 985,
	"./calendar.svg": 986,
	"./check.svg": 400,
	"./clock-circular-outline-white.svg": 987,
	"./clock-circular-outline.svg": 399,
	"./comerciales.svg": 407,
	"./complaint-empty-positive.png": 988,
	"./complaint-record-donut-preview.svg": 383,
	"./confirmed_Material_request.svg": 989,
	"./delete.svg": 990,
	"./destello.svg": 396,
	"./detalle_incidencia.svg": 991,
	"./download.svg": 992,
	"./downloader.svg": 993,
	"./edit.svg": 994,
	"./en_alerta.svg": 266,
	"./en_camino.svg": 394,
	"./en_progreso.svg": 218,
	"./erlenmeyer-flask--science-experiment-lab-flask-chemistry-solution.svg": 402,
	"./error.svg": 995,
	"./favicon.png": 996,
	"./file-download.svg": 997,
	"./gestion_usuarios.svg": 408,
	"./group_2608.svg": 998,
	"./ic_add_new.svg": 409,
	"./ic_agro_ia_bot.svg": 410,
	"./ic_alerts.svg": 999,
	"./ic_chatbot_ai.svg": 1000,
	"./ic_check.svg": 1001,
	"./ic_clock.svg": 1002,
	"./ic_copy_new.svg": 234,
	"./ic_crop.svg": 1003,
	"./ic_cross_alert.svg": 1004,
	"./ic_cultive.svg": 1005,
	"./ic_detalle_muestra.svg": 1006,
	"./ic_document_template.svg": 245,
	"./ic_download.svg": 94,
	"./ic_download_new.svg": 1007,
	"./ic_edit_new.svg": 162,
	"./ic_ficha.svg": 1008,
	"./ic_fichero_adjunto.svg": 1009,
	"./ic_filter.svg": 411,
	"./ic_filter_white.svg": 1010,
	"./ic_group.svg": 1011,
	"./ic_incidencia.svg": 1012,
	"./ic_info_alert.svg": 1013,
	"./ic_informe_respuesta.svg": 1014,
	"./ic_interpretation_ai.svg": 1015,
	"./ic_limits_corrections_ai.svg": 1016,
	"./ic_location.svg": 1017,
	"./ic_materialRequest_new.svg": 1018,
	"./ic_muestra.svg": 1019,
	"./ic_my_invoices.svg": 1020,
	"./ic_my_offers.svg": 1021,
	"./ic_new_materialRequest.svg": 1022,
	"./ic_new_sample.svg": 412,
	"./ic_offers_new.svg": 1023,
	"./ic_pencil.svg": 161,
	"./ic_reclamaciones_chatbot_2.png": 1024,
	"./ic_registro_online.svg": 1025,
	"./ic_reload_blue.svg": 1026,
	"./ic_save_new.svg": 316,
	"./ic_search.svg": 1027,
	"./ic_search_blue.svg": 1028,
	"./ic_service_catalgo.svg": 1029,
	"./ic_stack.svg": 397,
	"./ic_success_alert.svg": 401,
	"./ic_trash_new.svg": 104,
	"./ic_trip.svg": 1030,
	"./ic_upload_new.svg": 271,
	"./ic_user.svg": 1031,
	"./ic_user_management.svg": 1032,
	"./ic_user_profile.svg": 1033,
	"./ic_variety.svg": 1034,
	"./ic_visibility.svg": 73,
	"./ic_warning_alert.svg": 1035,
	"./iconfinder-new-contat.svg": 1036,
	"./last-samples-preview-color-v1.svg": 1037,
	"./last-samples-preview-color.svg": 384,
	"./logobsf_new.svg": 270,
	"./mail.svg": 1038,
	"./mapa.svg": 1039,
	"./mineria.svg": 268,
	"./muestra.svg": 388,
	"./notificaciones.svg": 413,
	"./nueva_incidencia.svg": 1040,
	"./nueva_muestra.svg": 1041,
	"./online-samples-register-cards-preview.svg": 385,
	"./options_burger.svg": 1042,
	"./or-ic-incidencia.svg": 398,
	"./pdf.svg": 1043,
	"./pendiente_envio.svg": 1044,
	"./pendiente_validar.svg": 1045,
	"./phone.svg": 1046,
	"./recibida.svg": 393,
	"./registro-Muestras-Empty-State-Icon.svg": 392,
	"./registro_online.svg": 269,
	"./servicios.svg": 414,
	"./sin_revisar.svg": 267,
	"./solicitar_material.svg": 1047,
	"./task.svg": 1048,
	"./ultimas-muestras-icon-empty-state.svg": 386,
	"./upload-green.svg": 382,
	"./upload.svg": 1049,
	"./ver-historial-ultimas-muestras.svg": 387,
	"./warning.svg": 1050,
	"./wt-ic-incidencia.svg": 1051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;